import { render } from "./Platforms.vue?vue&type=template&id=255465f3"
import script from "./Platforms.vue?vue&type=script&lang=js"
export * from "./Platforms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__